module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-7.f5172a6b.mp3";